(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const {variants, prices} = JSON.parse(root.querySelector('[data-tracker-data]').textContent);
    const select = root.querySelector('[data-tracker-variant]');
    const optionPanel = root.querySelector('[data-tracker-options]');
    const form = select.closest('form');
    root.querySelector('[data-tracker-fallback]').hidden = true;
    optionPanel.hidden = false;
    function showImage(id) {
      if (!id || !root.querySelector(`[data-tracker-image="${id}"]`)) return;
      root.querySelectorAll('[data-tracker-image]').forEach(image => image.hidden = image.dataset.trackerImage !== String(id));
      root.querySelectorAll('[data-tracker-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.trackerThumb === String(id))));
    }
    root.querySelectorAll('[data-tracker-thumb]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.trackerThumb)));
    function update() {
      const selected = [...optionPanel.querySelectorAll('input:checked')].map(input => input.value);
      const variant = variants.find(v => v.options.every((value, i) => value === selected[i]));
      const available = !!variant?.available;
      select.value = variant ? String(variant.id) : '';
      root.querySelector('[data-tracker-price]').innerHTML = variant ? prices[variant.id].price : 'Unavailable';
      const was = root.querySelector('[data-tracker-was]');
      was.hidden = !variant || !(variant.compare_at_price > variant.price);
      was.innerHTML = variant ? prices[variant.id].was : '';
      const add = root.querySelector('[data-tracker-add]');
      add.disabled = !available;
      add.textContent = available ? 'Add to cart' : variant ? 'Sold out' : 'Unavailable';
      root.querySelector('[data-tracker-buy]').disabled = !available;
      if (variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        showImage(variant.featured_image?.id);
      }
    }
    optionPanel.addEventListener('change', update);
    form.addEventListener('submit', event => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant?.available) event.preventDefault();
    });
  }
  document.querySelectorAll('[data-tracker-root]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-tracker-root]').forEach(initialize));
})();
